export default __webpack_public_path__ + "static/media/silhouette.252fc047.png";